/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.server.deleteWebhook";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"id":/*#__PURE__*/ l.string()});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"success":/*#__PURE__*/ l.boolean()});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Delete an existing webhook. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["WebhookNotFound","Unauthorized"]);

export { main };

export const $lxm = $nsid;
